import React from "react";
import { FaqMarkdownPage } from "../../components/FaqMarkdownPage";

// Routed at /faq/skills-matrix — content lives entirely in
// public/locales/faq/skills-self-assessment.*.md, editable without touching this file.
export const SkillsMatrixFaqPage: React.FC = () => (
    <FaqMarkdownPage
        titleKey="FAQ_SKILLS_MATRIX_TITLE"
        titleFallback="Skills Self-Assessment & Manager Confirmation"
        markdownBasePath="/locales/faq/skills-self-assessment"
    />
);
